<!--begin::Image input-->
<div #root class="image-input w-100 h-100" [class]="wrapperClasses" data-kt-image-input="true">
  <!--begin::Image preview wrapper-->
  <div class="image-input-wrapper w-100 h-100">
    <ng-container *ngIf="!isImageLoaded">
      <ng-content></ng-content>
    </ng-container>
  </div>
  <!--end::Image preview wrapper-->

  <!--begin::Edit button-->
  <label class="btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow"
         data-kt-image-input-action="change"
         data-bs-toggle="tooltip"
         data-bs-dismiss="click"
         title="Change avatar">
    <i class="bi bi-pencil-fill fs-7"></i>

    <!--begin::Inputs-->
    <input
      type="file"
      [accept]="allowedFileFormats"
      test-id="image-input"
    />
    <input type="hidden" name="avatar_remove"/>
    <!--end::Inputs-->
  </label>
  <!--end::Edit button-->

  <!--begin::Cancel button-->
  <span class="btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow"
        data-kt-image-input-action="cancel"
        data-bs-toggle="tooltip"
        data-bs-dismiss="click"
        title="Cancel avatar">
        <i class="bi bi-x fs-2"></i>
  </span>
  <!--end::Cancel button-->

  <!--begin::Remove button-->
  <span
    class="btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow"
    data-kt-image-input-action="remove"
    data-bs-toggle="tooltip"
    data-bs-dismiss="click"
    title="Remove avatar"
    (click)="deleteLogo()"
    [class.disabled]="!isImageLoaded"
    >
        <i class="bi bi-x fs-2"></i>
  </span>
  <!--end::Remove button-->
</div>
<!--end::Image input-->
